import React, { useEffect, useState } from 'react';
import { ChartsDataCountSerieCampanha } from '../../config/api/index.js';
import { getCountingColorWithValue, statusOrder, convertStatusName, getPlotlyPlot } from './ChartsUtils';
import ReactResizeDetector from 'react-resize-detector';

var state;
var jsx = null;

const BarChartly = (props) => {
    //Get localized reac-plotly plot
    const Plot = getPlotlyPlot();

    const [data, setData] = useState([]);
    const [siz, setSiz] = useState({});

    const [forceupdate, setForceUpdate] = useState({});

    const graph = (props) => {
        if (!state || forceupdate) {
            state = getNewPlot(props);
            setForceUpdate(false);
            jsx = null;
        }
        return getOldPlot(state);
    }

    function getNewPlot(props) {
        return (
            {
                data: data,
                layout: {
                    width: siz.width,
                    height: siz.height,
                    barmode: 'stack',
                    yaxis: { categoryorder: "sum descending" },
                    showlegend: true,
                    legend: { orientation: 'h', xanchor: 'center', yanchor: 'top' },
                    margin: { l: 40, r: 10, b: 10, t: 10, pad: 4 }
                },
                style: { width: "98%", height: "95%", position: "absolute" },
                useResizeHandler: true,
                responsive: true,
                config: {
                    displaylogo: false,
                    displayModeBar: false,
                    modeBarButtonsToRemove: ['sendDataToCloud', 'hoverCompareCartesian', 'hoverClosestCartesian', 'lasso2d', 'select2d', 'autoScale2d']
                }
            }
        );
    }

    function getOldPlot(props) {
        if (!jsx) {
            jsx = (
                <Plot
                    data={state.data}
                    layout={state.layout}
                    config={state.config}
                />
            );
        }
        return jsx;
    }

    function formatData(data) {
        var datum = [];
        var map = {};

        data.forEach(el => {
            let limit;
            let separator;
            if (el.status === statusOrder[2]) {
                limit = el.limiteQuantificacaoSuperior
                separator = ' > '
            }
            else if (el.status === statusOrder[0]) {
                limit = el.limiteQuantificacaoInferior
                separator = ' < '
            }
            else {
                limit = ''
                separator = ''
            }
            var key = el.status + separator + limit;
            if (key in map) {
                map[key][el.serie] = el.counter
            }
            else {
                var serieCampanha = {};
                serieCampanha[el.serie] = el.counter;
                map[key] = serieCampanha;
            }
        });

        Object.keys(map).forEach(el => {
            var obj = {};
            obj['campanha'] = [];
            obj['valores'] = [];
            obj['nomeSerie'] = el;
            Object.keys(map[el]).forEach(e => {
                obj['campanha'].push(e);
                obj['valores'].push(map[el][e]);
            });
            datum.push(obj);
        });

        return datum;
    }

    useEffect(() => {
        (async () => {

            if (!props.parametroSerie) return
            let dat = [];
            let intermediario = await ChartsDataCountSerieCampanha(props.parametroSerie.parametro, props.parametroSerie.seriesHabilitadas);
            const data = formatData(intermediario)

            data.sort(function (e1, e2) {
                const i1 = statusOrder.indexOf(e1.nomeSerie.split(" ")[0]);
                const i2 = statusOrder.indexOf(e2.nomeSerie.split(" ")[0]);
                if (i1 > i2) return 1;
                if (i2 > i1) return -1;
                return 0;
            });

            let meta = {};
            data.forEach(d => {
                const splitted = (d.nomeSerie).split(' ');
                const stat = splitted[0];
                if (splitted.length > 1) {
                    if (splitted[0] in meta) meta[stat].push(Number(splitted[2]));
                    else {
                        meta[stat] = [];
                        meta[stat].push(Number(splitted[2]));
                    }
                }
            })

            data.forEach(element => {
                const splitted = (element.nomeSerie).split(' ');
                const eName = splitted[0];
                let eValues = null;
                if (meta[eName] !== undefined) eValues = meta[eName];
                const eValue = (element.nomeSerie).split(' ')[2];
                dat.push(
                    {
                        type: 'bar',
                        x: element.campanha,
                        y: element.valores,
                        marker: {
                            color: getCountingColorWithValue(eName, eValues, eValue)
                        },
                        name: convertStatusName(element.nomeSerie)
                    }
                );
            });
            setData(dat);
            setForceUpdate(true);
        })()
    }, [props.parametroSerie])

    const onResize = (width, height) => {
        setSiz({ width: width, height: height });
        setForceUpdate(true);
    }

    return (
        <div style={{ position: "absolute", width: "98%", height: "94%" }}>
            {graph(props)}
            <ReactResizeDetector handleWidth handleHeight onResize={onResize} />
        </div>
    );

}

export default BarChartly;